import React, { useCallback, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Button, useDisclosure } from "@chakra-ui/react";
import { useGetPendingPayouts } from "api/invoicing";
import PendingPayoutsModal from "./PendingPayoutsModal";

const PendingPayoutsButton = ({ onUpdate }) => {
  const [pendingPayouts, setPendingPayouts] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data, isSuccess, error, refetch } = useGetPendingPayouts();

  useEffect(() => {
    if (isSuccess) {
      setPendingPayouts(data.payload.transactions);
    }
  }, [isSuccess, setPendingPayouts, data]);

  useEffect(() => {
    // silently fail and hide the button
    if (error) {
      setPendingPayouts([]);
    }
  }, [error, setPendingPayouts]);

  const handleOnUpdate = useCallback(() => {
    refetch();
    onUpdate();
  }, [refetch, onUpdate]);

  const length = pendingPayouts.length;

  if (length === 0) {
    return null;
  }
  return (
    <>
      <Button
        variant="link"
        size="xs"
        onClick={onOpen}
      >
        {length === 1 ? (
          <FormattedMessage defaultMessage="You have 1 pending payout..." description="Informative message" />
        ) : (
          <FormattedMessage
            defaultMessage="You have {totalNumber} pending payouts..."
            description="Infromative message. Example: You have 3 pending payouts"
            values={{
              totalNumber: length,
            }}
          />
        )}
      </Button>
      <PendingPayoutsModal
        isOpen={isOpen}
        onClose={onClose}
        onUpdate={handleOnUpdate}
        pendingPayouts={pendingPayouts}
      />
    </>
  );
};

export default PendingPayoutsButton;
